export const DEMO_URL = 'https://app.matchpool.live/t/demo';
export const ADMIN_URL = 'https://app.matchpool.live/admin/login';
